import { isValidToken } from '~/lib/utils';

let refreshPromise = null;

const clearSessionState = () => {
  if (import.meta.client) {
    localStorage.removeItem('tokens');
    localStorage.removeItem('useUser');
    localStorage.removeItem('ownerStore');
    localStorage.removeItem('parkerStore');
  }

  useTokens().reset();
  useUser().$reset();
  useCosmo().$reset();
};

export const useSessionGuard = () => {
  const validateSession = async () => {
    if (import.meta.server) {
      return { authenticated: false };
    }

    const tokensStore = useTokens();
    const userStore = useUser();
    const accessToken = tokensStore.access;
    const refreshToken = tokensStore.refresh;
    const hasUserSession = Boolean(
      userStore.getUser?.id || userStore.access_token || userStore.refresh_token
    );

    if (accessToken && isValidToken(accessToken)) {
      return { authenticated: true };
    }

    if (!refreshToken) {
      if (hasUserSession) {
        clearSessionState();
      }

      return { authenticated: false };
    }

    if (!refreshPromise) {
      refreshPromise = useRefreshAccessToken(refreshToken)
        .then((newAccessToken) => {
          tokensStore.setAccessToken(newAccessToken);
          userStore.setTokens(newAccessToken, refreshToken);
          return newAccessToken;
        })
        .finally(() => {
          refreshPromise = null;
        });
    }

    try {
      await refreshPromise;
      return { authenticated: true };
    } catch (error) {
      clearSessionState();
      return { authenticated: false, error };
    }
  };

  return {
    validateSession,
  };
};
